import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';
import { formatDate } from '@koob/dates';

export interface FolderPassportExpiryProps {
  expirationDate?: string | null;
  expiresBeforeReturn: boolean;
  returnDate?: string | null;
}

/**
 * KD-3842: passport expiry (MM/YYYY) with a warning when it falls before the
 * trip return date. No other validity rule: they vary by destination.
 */
export default function FolderPassportExpiry({
  expirationDate,
  expiresBeforeReturn,
  returnDate,
}: FolderPassportExpiryProps) {
  const { t } = useTranslation('folders');

  if (!expirationDate) {
    return <span className="text-gray-400">--</span>;
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      {formatDate(expirationDate, 'MM/YYYY')}
      {expiresBeforeReturn && (
        <KoobTooltip
          tip={t('travelers.expiresBeforeReturn', {
            date: formatDate(returnDate, 'DD/MM/YYYY'),
          })}
        >
          <i
            className="fa-solid fa-triangle-exclamation text-amber-500"
            aria-label={t('travelers.expiresBeforeReturn', {
              date: formatDate(returnDate, 'DD/MM/YYYY'),
            })}
          />
        </KoobTooltip>
      )}
    </span>
  );
}
